import settings from "@src/settings";
import React from "react";
import styled from "styled-components";
import { GatsbyImageProps } from "gatsby-plugin-image";

interface Props {
	img:
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>;
	className?: string;
}

const ImgFrame = styled.figure`
	flex: auto 1 1;
	background-color: #ddd;
	border-radius: ${settings.radius.small}px;
	overflow: hidden;
`;

const VoiceIntroImage: React.FC<Props> = (props) => {
	const { img, className } = props;
	return <ImgFrame className={className}>{img}</ImgFrame>;
};

export default styled(VoiceIntroImage)``;
